import { defineComponent, ref, computed, watch, openBlock, createElementBlock, normalizeClass, createVNode, unref, Fragment, createElementVNode, renderList, createBlock, normalizeStyle, createCommentVNode, mergeProps } from "vue";
import _sfc_main$1 from "../VisibilityTracker/VisibilityTracker.mjs";
import { EProductReviewsErrorState } from "../../types/pinia/ProductReviewsModel.mjs";
import ProductReviewsReviewThis from "./ProductReviewsReviewThis/ProductReviewsReviewThis.mjs";
import _sfc_main$3 from "../ProductReviewsDropdownSort/ProductReviewsDropdownSort.mjs";
import ProductReviewsAverageRatingBar from "./ProductReviewsAverageRatingBar/ProductReviewsAverageRatingBar.mjs";
import ProductReviewsRatingOverview from "./ProductReviewsRatingOverview/ProductReviewsRatingOverview.mjs";
import ProductReviewsRatingSnapshot from "./ProductReviewsRatingSnapshot/ProductReviewsRatingSnapshot.mjs";
import ProductReviewsIndividualReview from "./ProductReviewsIndividualReview/ProductReviewsIndividualReview.mjs";
import _sfc_main$2 from "./ProductReviewsMostHelpfulFeaturedReviews/ProductReviewsMostHelpfulFeaturedReviews.mjs";
/* empty css                                                                                    */
import ProductReviewsPills from "./ProductReviewsPills/ProductReviewsPills.mjs";
import ProductReviewsPagination from "./ProductReviewsPagination/ProductReviewsPagination.mjs";
import ProductReviewsErrorStateBanner from "./ProductReviewsErrorStateBanner/ProductReviewsErrorStateBanner.mjs";
import ProductReviewsImageCarousel from "./ProductReviewsImageCarousel/ProductReviewsImageCarousel.mjs";
import ProductReviewsWarningStateBanner from "./ProductReviewsWarningStateBanner/ProductReviewsWarningStateBanner.mjs";
const _hoisted_1 = {
  class: "product-reviews__no-reviews product-reviews__section product-reviews__review-this"
};
const _hoisted_2 = {
  class: "product-reviews__reviews-summary product-reviews__section"
};
const _hoisted_3 = {
  class: "product-reviews__rating-snapshot"
};
const _hoisted_4 = {
  class: "product-reviews__product-rating"
};
const _hoisted_5 = {
  class: "product-reviews__section product-reviews__review-this"
};
const _hoisted_6 = {
  class: "product-reviews__average-ratings-container"
};
const _hoisted_7 = {
  key: 1,
  class: "product-reviews__most-helpful-container product-reviews__section"
};
const _hoisted_8 = {
  class: "product-reviews__most-helpful-review"
};
const _hoisted_9 = {
  class: "product-reviews__most-helpful-review"
};
const _hoisted_10 = {
  key: 2,
  class: "product-reviews__customer-images product-reviews__section"
};
const _hoisted_11 = {
  id: "reviews-filters",
  class: "product-reviews__reviews-controls"
};
const _hoisted_12 = {
  class: "product-reviews__filter-pills"
};
const _hoisted_13 = {
  key: 2,
  class: "product-reviews__pagination"
};
const _hoisted_14 = {
  key: 4
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviews",
  props: {
    summary: {},
    reviews: {},
    userStars: {},
    showReviews: {
      type: Boolean
    },
    secondaryReviewsAvg: {},
    filterStarRating: {},
    errorState: {},
    showXlBreakpoint: {
      type: Boolean
    },
    reviewPhotos: {},
    reviewsWithPhotos: {},
    helpfulReviews: {}
  },
  emits: ["metricsClick", "reviewStarClick", "productRatingFilterClick", "individualReviewFeedbackClick", "modalOpen", "productReviewsSort", "productReviewsStarsChanged", "productReviewsPagination"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const root = ref();
    const reviewsToRender = computed(() => {
      if (!props.reviews.content) return [];
      return props.reviews.content;
    });
    const enableFavorableReviewsPanel = computed(() => {
      const {
        totalReviewCount,
        fiveStarRatingCount,
        fourStarRatingCount,
        threeStarRatingCount,
        twoStarRatingCount,
        oneStarRatingCount,
        mostFavorableReview,
        mostCriticalReview
      } = props.summary;
      const {
        totalFeedbackCount
      } = mostFavorableReview || {
        totalFeedbackCount: 0
      };
      const positiveReview = fiveStarRatingCount + fourStarRatingCount > 1 && totalFeedbackCount > 3;
      const criticalReview = threeStarRatingCount + twoStarRatingCount + oneStarRatingCount > 1 && totalFeedbackCount > 3;
      return totalReviewCount > 10 && positiveReview && criticalReview && mostCriticalReview;
    });
    const productReviewsReviewRef = ref();
    const dropdownRef = ref();
    const filters = computed(() => Object.keys(props.filterStarRating));
    watch(() => props.reviews.minimumElementOnPage, () => {
      var _a;
      if (productReviewsReviewRef.value && typeof window !== "undefined") {
        const select = (_a = dropdownRef.value) == null ? void 0 : _a.getElementsByTagName("select");
        if (select) {
          select[0].focus();
          select[0].blur();
        }
        const distance = productReviewsReviewRef.value.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: distance
        });
      }
    });
    const openMapModal = ({
      reviews,
      photoIndex,
      reviewIndex
    }) => {
      const modalData = {
        ariaDescribedBy: "description",
        modalContent: "ProductReviewsReviewModal",
        id: reviews.value.length === 1 && reviews.value[0].photos.length === 0 ? "product-review-modal--no-media" : "product-review-modal",
        label: "",
        modalProps: {
          reviews,
          photoIndex,
          reviewIndex
        }
      };
      emit("metricsClick", {
        linkName: "pdp_reviews_open review"
      });
      emit("modalOpen", modalData);
    };
    const showIndividualReviews = computed(() => props.errorState === EProductReviewsErrorState.NONE);
    const showFilterWarningMessage = computed(() => reviewsToRender.value.length === 0 && filters.value.length > 0);
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        ref_key: "root",
        ref: root,
        class: normalizeClass(["product-reviews", _ctx.showXlBreakpoint && "product-reviews--xl"])
      }, [createVNode(unref(_sfc_main$1), {
        "link-name": "pdp_reviews_view",
        onMetricsClick: _cache[0] || (_cache[0] = (data) => emit("metricsClick", data))
      }), !_ctx.showReviews ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [createElementVNode("div", _hoisted_1, [_cache[19] || (_cache[19] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Review this Product ", -1)), createVNode(unref(ProductReviewsReviewThis), {
        "user-stars": props.userStars,
        onMetricsClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("metricsClick", data)),
        onReviewStarClick: _cache[2] || (_cache[2] = (rating) => emit("reviewStarClick", rating))
      }, null, 8, ["user-stars"])]), _cache[20] || (_cache[20] = createElementVNode("div", {
        class: "product-reviews__divider"
      }, null, -1))], 64)) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [createElementVNode("div", _hoisted_2, [createElementVNode("section", _hoisted_3, [_cache[21] || (_cache[21] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Ratings Snapshot ", -1)), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.summary.ratingCounts, (entry) => {
        return openBlock(), createBlock(unref(ProductReviewsRatingSnapshot), {
          key: entry.rating,
          count: entry.count,
          percentage: entry.percentage,
          rating: entry.rating,
          onMetricsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("metricsClick", data)),
          onProductRatingFilterClick: _cache[4] || (_cache[4] = (rating) => _ctx.$emit("productRatingFilterClick", rating))
        }, null, 8, ["count", "percentage", "rating"]);
      }), 128))]), createElementVNode("section", _hoisted_4, [_cache[22] || (_cache[22] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Product Rating ", -1)), createVNode(unref(ProductReviewsRatingOverview), {
        "average-rating": _ctx.summary.averageOverallRating,
        "review-count": _ctx.summary.totalReviewCount,
        "positive-recs": _ctx.summary.recommended,
        "total-recs": _ctx.summary.recommended + _ctx.summary.notRecommended,
        "recommended-percentage": _ctx.summary.recommendedPercentage,
        onMetricsClick: _cache[5] || (_cache[5] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["average-rating", "review-count", "positive-recs", "total-recs", "recommended-percentage"])]), createElementVNode("section", _hoisted_5, [_cache[23] || (_cache[23] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Review this Product ", -1)), createVNode(unref(ProductReviewsReviewThis), {
        "user-stars": props.userStars,
        "has-reviews": true,
        onMetricsClick: _cache[6] || (_cache[6] = (data) => _ctx.$emit("metricsClick", data)),
        onReviewStarClick: _cache[7] || (_cache[7] = (rating) => emit("reviewStarClick", rating))
      }, null, 8, ["user-stars"])])]), props.summary.secondaryReviewsAvg ? (openBlock(), createElementBlock("section", {
        key: 0,
        class: "product-reviews__average-ratings product-reviews__section",
        style: normalizeStyle({
          "--ratings-count": (_a = props.summary.secondaryReviewsAvg) == null ? void 0 : _a.length
        })
      }, [_cache[24] || (_cache[24] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Average Customer Ratings ", -1)), createElementVNode("div", _hoisted_6, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.summary.secondaryReviewsAvg, (review) => {
        return openBlock(), createBlock(unref(ProductReviewsAverageRatingBar), {
          key: review.id,
          id: review.id,
          "average-rating": review.averageRating,
          "value-range": review.valueRange,
          "max-label": review.maxLabel,
          "min-label": review.minLabel,
          label: review.label
        }, null, 8, ["id", "average-rating", "value-range", "max-label", "min-label", "label"]);
      }), 128))])], 4)) : createCommentVNode("", true), enableFavorableReviewsPanel.value ? (openBlock(), createElementBlock("section", _hoisted_7, [createElementVNode("div", _hoisted_8, [_cache[25] || (_cache[25] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Most Helpful Favorable Review ", -1)), createVNode(unref(_sfc_main$2), {
        data: _ctx.helpfulReviews.mostFavorableReview,
        onMetricsClick: _cache[8] || (_cache[8] = (data) => _ctx.$emit("metricsClick", data)),
        onOpenMapModal: openMapModal
      }, null, 8, ["data"])]), createElementVNode("div", _hoisted_9, [_cache[26] || (_cache[26] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Most Helpful Critical Review ", -1)), createVNode(unref(_sfc_main$2), {
        data: _ctx.helpfulReviews.mostCriticalReview,
        onMetricsClick: _cache[9] || (_cache[9] = (data) => _ctx.$emit("metricsClick", data)),
        onOpenMapModal: openMapModal
      }, null, 8, ["data"])])])) : createCommentVNode("", true), _ctx.reviewPhotos.length > 0 ? (openBlock(), createElementBlock("section", _hoisted_10, [_cache[27] || (_cache[27] = createElementVNode("h3", {
        class: "product-reviews__section-title"
      }, " Customer Images ", -1)), createVNode(unref(ProductReviewsImageCarousel), {
        "review-arr": _ctx.reviewsWithPhotos,
        "photo-arr": _ctx.reviewPhotos,
        onOpenMapModal: openMapModal,
        onMetricsClick: _cache[10] || (_cache[10] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["review-arr", "photo-arr"])])) : createCommentVNode("", true), createElementVNode("div", _hoisted_11, [createElementVNode("div", _hoisted_12, [createVNode(unref(ProductReviewsPills), {
        "filter-star-rating": _ctx.filterStarRating,
        onMetricsClick: _cache[11] || (_cache[11] = (data) => emit("metricsClick", data)),
        onProductReviewsStarsChanged: _cache[12] || (_cache[12] = (payload) => emit("productReviewsStarsChanged", payload))
      }, null, 8, ["filter-star-rating"])]), createElementVNode("div", {
        ref_key: "dropdownRef",
        ref: dropdownRef,
        class: "product-reviews__reviews-sort"
      }, [createVNode(unref(_sfc_main$3), {
        onMetricsClick: _cache[13] || (_cache[13] = (data) => emit("metricsClick", data)),
        onProductReviewsSort: _cache[14] || (_cache[14] = (payload) => emit("productReviewsSort", payload))
      })], 512)]), showIndividualReviews.value ? (openBlock(), createElementBlock("section", {
        key: 3,
        id: "first-review",
        ref_key: "productReviewsReviewRef",
        ref: productReviewsReviewRef,
        class: "product-reviews__reviews-list product-reviews__section",
        "aria-label": "Reviews"
      }, [showFilterWarningMessage.value ? (openBlock(), createBlock(unref(ProductReviewsWarningStateBanner), {
        key: 0
      })) : (openBlock(true), createElementBlock(Fragment, {
        key: 1
      }, renderList(reviewsToRender.value, (review) => {
        return openBlock(), createBlock(unref(ProductReviewsIndividualReview), mergeProps({
          key: review.id,
          ref_for: true
        }, review, {
          author: review.author,
          "syndication-details": review.syndicationDetails,
          "would-recommend": review.wouldRecommend,
          onMetricsClick: _cache[15] || (_cache[15] = (data) => _ctx.$emit("metricsClick", data)),
          onOpenMapModal: openMapModal,
          onIndividualReviewFeedbackClick: _cache[16] || (_cache[16] = (body) => emit("individualReviewFeedbackClick", body))
        }), null, 16, ["author", "syndication-details", "would-recommend"]);
      }), 128)), _ctx.reviews.totalElements > 10 ? (openBlock(), createElementBlock("div", _hoisted_13, [createVNode(unref(ProductReviewsPagination), {
        "total-elements": _ctx.reviews.totalElements,
        "minimum-element": _ctx.reviews.minimumElementOnPage,
        size: ((_b = reviewsToRender.value) == null ? void 0 : _b.length) ?? 0,
        onMetricsClick: _cache[17] || (_cache[17] = (data) => _ctx.$emit("metricsClick", data)),
        onProductReviewsPagination: _cache[18] || (_cache[18] = (payload) => {
          emit("productReviewsPagination", payload);
        })
      }, null, 8, ["total-elements", "minimum-element", "size"])])) : createCommentVNode("", true)], 512)) : (openBlock(), createElementBlock("section", _hoisted_14, [createVNode(unref(ProductReviewsErrorStateBanner))]))], 64))], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviews2.mjs.map
